<template>
  <v-app>
    <scroll>
      <div>
        <BaseNavbar class="mb-12" />
        <v-main>
          <v-container fluid style="max-width: 96%">
            <!-- <v-alert border="left" color="blue" type="info" preminent>
              <h3>
                COMUNICADO AOS FORNECEDORES DO SEBRAE/BA PARADA TÉCNICA DO
                SISTEMA DE PAGAMENTOS - GFS
              </h3>
              <span>
                <br />
                Prezados Fornecedores,
                <br />
                Lembramos que o prazo para o envio das notas fiscais para o financeiro, referente ao encerramento do exercício de 2024, encerra-se  dia 15/12/2024.
                <br/>
                Para garantir que todos os processos sejam concluídos dentro do prazo, solicitamos que as notas sejam encaminhadas o quanto antes.
                <br/>
                Caso tenha alguma dúvida ou precise de assistência, estamos à disposição.
                
                <br /><br />

                Atenciosamente, <br />
                SEBRAE/BA <br />
                UFIN-UNIDADE DE FINANÇAS DAF
                <br />DIRETORIA DE ADMINISTRAÇÃO E FINANÇAS.
              </span>
            </v-alert> -->

            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </v-container>
        </v-main>
      </div>
    </scroll>
  </v-app>
</template>

<script>
import BaseNavbar from "../Template/BaseNavbar";
import Scroll from "../UI/BaseScroll";

export default {
  components: {
    BaseNavbar,
    Scroll
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
